import React, { FC, useEffect, useState } from 'react';
import AdminLayout from 'src/components/layout/RoleLayout';
import { IAgencyInfo } from 'src/types/app';
import { RouteComponentProps } from 'react-router';
import { QueryParams } from 'src/types/grid';
import Loader from 'src/components/Loader';
import styles from './assets/agency-info.module.scss';
import AgencyInfoComponent from './components/AgencyInfoComponent';
import AgencyForm from './components/AgencyForm';
import classNames from 'classnames';

export interface StateProps {
    agencyInfo: IAgencyInfo | null;

    miniLoaderFor: { [key: string]: boolean };
}
export interface DispatchProps {
    getData: (params: QueryParams) => void;
    addFiles: (id: any, files: any) => void;
}

interface RouteParams {
    type: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const AgencyInfo: FC<Props> = (props: Props) => {
    const [files, setFiles] = useState<any>([]);
    useEffect(() => {
        props.getData({
            page: 1,
            itemsPerPage: 1200,
        });
        // eslint-disable-next-line
    }, []);

    const {
        addFiles,

        miniLoaderFor,
        match: {
            params: { type },
        },
    } = props;

    if (!props.agencyInfo) {
        return <Loader />;
    }
    const handeAdd = (files: any) => {
        addFiles(`${props.agencyInfo?.id}`, [files[files.length - 1]]);
        const file = files[files.length - 1];
        const filesIn = [
            {
                attach: file.attach,
                mimeType: file.mimeType,
                name: file.name,
            },
        ];
        setFiles(filesIn);
    };

    const typeChoose: string = type ? type : 'info';

    const typesPage: any = {
        info: <AgencyInfoComponent {...props.agencyInfo} />,
        edit: (
            <AgencyForm
                miniLoaderFor={miniLoaderFor}
                files={files}
                logoDoc={props.agencyInfo?.logoDoc}
                handeAdd={handeAdd}
                initialValues={{ ...props.agencyInfo }}
            />
        ),
    };

    return (
        <AdminLayout>
            <div className={classNames(styles.flex)}>
                <div className={classNames(styles.leftCol)}>
                    <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                        <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>AGENCY INFO</h2>
                    </div>
                    <div className={classNames(styles.detailWrap)}>{typesPage[typeChoose]}</div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default AgencyInfo;
